import { RE_SETUP } from "./peekHandleKeys";

const configsByPeekHandleKey = {
  navColorKey: {
    [RE_SETUP]: "signups",
  },
};

export default configsByPeekHandleKey;
